module.exports = __webpack_public_path__ + "img/sdk.6b795fb2.png";